export const GOOGLE_LOGIN_URL = '/auth/google';
export const LOGOUT_URL = '/api/logout';
export const SURVEYS_URL = '/surveys';
export const SURVEY_NEW_URL = '/surveys/new';